import React from "react";
import FormWrapper from "../shared/FormWrapper";

export default function ProfileCelebration({
  formData,
  imagePreview,
  onPreviewProfile,
  onFinish,
}) {
  const fallbackAvatarUrl =
    "https://static-00.iconduck.com/assets.00/profile-circle-icon-1023x1024-ucnnjrj1.png";

  return (
    <FormWrapper showPattern={false}>
      <div style={{ textAlign: "center" }}>
        {/* Confetti-style decorative elements - spans full width */}
        <div
          style={{
            position: "absolute",
            top: "16px",
            left: "0",
            right: "0",
            height: "60px",
            pointerEvents: "none",
            overflow: "hidden",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 24px",
          }}
        >
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: ["#10b981", "#3b82f6", "#f59e0b", "#ec4899", "#8b5cf6", "#06b6d4"][i],
                animation: `float ${2 + i * 0.3}s ease-in-out infinite`,
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>

        {/* Success Animation */}
        <div
          style={{
            width: "100px",
            height: "100px",
            backgroundColor: "#10b981",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px",
            animation: "scaleIn 0.5s ease, pulse 2s ease-in-out infinite 0.5s",
            boxShadow: "0 8px 32px rgba(16, 185, 129, 0.4)",
          }}
        >
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ animation: "fadeInUp 0.5s ease 0.3s both" }}
          >
            <path d="M22 2L11 13" />
            <path d="M22 2L15 22L11 13L2 9L22 2Z" />
          </svg>
        </div>

        {/* Celebration Header */}
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#1a1a1a",
            marginBottom: "12px",
            letterSpacing: "-0.02em",
            animation: "fadeInUp 0.5s ease 0.2s both",
          }}
        >
          Your application has been submitted!
        </h1>

        <p
          style={{
            fontSize: "17px",
            color: "#737373",
            marginBottom: "32px",
            lineHeight: "1.5",
            animation: "fadeInUp 0.5s ease 0.3s both",
          }}
        >
          We've sent a verification request to your church reference. Your profile will be visible once they confirm.
        </p>

        {/* Profile Preview Card */}
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "12px",
            padding: "24px",
            marginBottom: "32px",
            boxShadow: "0 4px 24px rgba(0, 0, 0, 0.06)",
            animation: "fadeInUp 0.5s ease 0.4s both",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "16px",
            }}
          >
            <div style={{ position: "relative" }}>
              <img
                src={imagePreview || fallbackAvatarUrl}
                alt="Profile"
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "3px solid #fff",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "2px",
                  right: "2px",
                  width: "18px",
                  height: "18px",
                  backgroundColor: "#10b981",
                  borderRadius: "50%",
                  border: "2px solid #fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
            </div>
            <div style={{ textAlign: "left", flex: 1 }}>
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#1a1a1a",
                  margin: "0 0 4px 0",
                }}
              >
                {formData.name || "Your Name"}
              </h3>
              <p style={{ fontSize: "15px", color: "#737373", margin: 0, display: "flex", alignItems: "center", gap: "4px" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                {formData.location || "Your Location"}
              </p>
            </div>
          </div>

          {formData.skillTitle && (
            <p
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#1a1a1a",
                margin: "0 0 12px 0",
                textAlign: "left",
                fontStyle: "italic",
              }}
            >
              {formData.skillTitle}
            </p>
          )}

          {formData.bio && (
            <p
              style={{
                fontSize: "14px",
                color: "#525252",
                margin: "0 0 16px 0",
                textAlign: "left",
                lineHeight: "1.6",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {formData.bio}
            </p>
          )}

          {formData.churchName && (
            <div
              style={{
                paddingTop: "16px",
                borderTop: "1px solid #f3f4f6",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#3b82f6"
                strokeWidth="2"
              >
                <path d="M3 21h18" />
                <path d="M5 21V7l7-4 7 4v14" />
                <path d="M9 21v-4h6v4" />
              </svg>
              <p style={{ fontSize: "14px", color: "#525252", margin: 0 }}>
                {formData.churchName}
                {formData.churchCity && `, ${formData.churchCity}`}
              </p>
            </div>
          )}
        </div>

        {/* Preview Profile Button */}
        <button
          onClick={onPreviewProfile}
          style={{
            width: "100%",
            padding: "14px 24px",
            fontSize: "15px",
            fontWeight: "500",
            color: "#525252",
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "8px",
            cursor: "pointer",
            marginBottom: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            transition: "all 0.2s ease",
            animation: "fadeInUp 0.5s ease 0.5s both",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#1a1a1a";
            e.currentTarget.style.backgroundColor = "#fafafa";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#e5e5e5";
            e.currentTarget.style.backgroundColor = "#fff";
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Preview your full profile
        </button>

        {/* Start Exploring CTA */}
        <button
          onClick={onFinish}
          style={{
            width: "100%",
            padding: "16px 24px",
            fontSize: "16px",
            fontWeight: "600",
            color: "#fff",
            backgroundColor: "#1a1a1a",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            marginBottom: "16px",
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            animation: "fadeInUp 0.5s ease 0.6s both",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#333";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#1a1a1a";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          Start exploring
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            50% { transform: translateY(-10px) rotate(5deg); }
          }
          @keyframes scaleIn {
            from { transform: scale(0); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0%, 100% { box-shadow: 0 8px 32px rgba(16, 185, 129, 0.4); }
            50% { box-shadow: 0 8px 48px rgba(16, 185, 129, 0.6); }
          }
        `}
      </style>
    </FormWrapper>
  );
}
